import BaseService from "./Core/BaseService";

class TermsService extends BaseService {
    get Url() { return super.Url + "/terms"; }
    
    async Accept() {
        try {
            return await this.SendRequest(BaseService.POST, {}, null, '/accept');
        } catch (error) {
            throw error;
        }
    }
}

export const service = new TermsService();

